import {MetaInterface} from "./meta.interface";

export enum AnalyticsType {
  GoogleAnalytics = 'GOOGLE_ANALYTICS',
  FacebookPixel = 'FACEBOOK_PIXEL'
}
export interface AnalyticsInterface {
  id?: string,
  title?: string,
  type: AnalyticsType
  active: boolean,
  token: string
}

export interface AnalyticsListResponse {
  data: AnalyticsInterface[]
  meta: MetaInterface
}

export const ANALYTICS_TYPE_LABELS: Record<AnalyticsType, string> = {
  [AnalyticsType.GoogleAnalytics]: 'AnalyticsType.GoogleAnalytics',
  [AnalyticsType.FacebookPixel]: 'AnalyticsType.FacebookPixel',
}
